import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7', fontFamily: 'Outfit, sans-serif' }}>

      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #ffcdd2', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#d32f2f', display: 'flex', alignItems: 'center' }}>
          ←
        </button>
        <div>
          <div style={{ fontWeight: 800, fontSize: 17, color: '#1a1a2e' }}>🔒 Privacy Policy</div>
          <div style={{ fontSize: 11, color: '#888' }}>Last updated: 26 April 2026</div>
        </div>
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '28px 20px 60px' }}>

        {/* Intro card */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', marginBottom: 20, border: '1px solid #ffcdd2', boxShadow: '0 2px 12px rgba(211,47,47,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg,#d32f2f,#e53935)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>🔒</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 20, color: '#1a1a2e' }}>Privacy Policy</div>
              <div style={{ fontSize: 13, color: '#888' }}>HCEN — Healthcare Emergency Network</div>
            </div>
          </div>
          <p style={{ color: '#555', fontSize: 14, lineHeight: 1.75, margin: 0 }}>
            HCEN is committed to protecting your privacy. This policy explains how we collect, use, and protect your personal and health information when you use the HCEN patient app and website.
          </p>
        </div>

        {[
          {
            icon: '📋', title: '1. Information We Collect',
            items: [
              'Name, mobile number, date of birth, gender',
              'Health information: symptoms, medical history, uploaded reports, appointment records',
              'Location data to show nearby hospitals (only with your permission)',
              'Device type, app version, and usage data to improve performance',
            ]
          },
          {
            icon: '🎯', title: '2. How We Use Your Information',
            items: [
              'To book, manage, and confirm hospital appointments',
              'To send OTP verification via WhatsApp/SMS',
              'To provide AI-powered symptom checking and report analysis',
              'To show personalised nearby hospitals based on location',
              'To send appointment reminders and health notifications',
              'To process consultation payments securely',
            ]
          },
          {
            icon: '🏥', title: '3. Healthcare Data & Confidentiality',
            items: [
              'Your health data is treated with the highest confidentiality',
              'Medical reports and AI chat history are stored securely and never shared without consent',
              'Hospitals only see information needed for your appointment (name, age, symptoms, booking)',
              'We NEVER sell your health data to advertisers or insurance companies',
            ]
          },
          {
            icon: '🤝', title: '4. Data Sharing',
            items: [
              'Hospitals: Only appointment-related info is shared with your booked hospital',
              'MSG91: WhatsApp/SMS partner for OTP and notifications only',
              'Razorpay: Payment gateway for secure transaction processing (PCI-DSS Level 1 certified)',
              'We do NOT share data with any other third party without your consent',
            ]
          },
          {
            icon: '🔐', title: '5. Data Security',
            items: [
              'All data is encrypted in transit using HTTPS/TLS',
              'Stored on AWS with industry-standard security protocols',
              'OTP-based login — no passwords are stored',
              'Access strictly limited to authorised HCEN staff only',
            ]
          },
          {
            icon: '📅', title: '6. Data Retention',
            items: [
              'Appointment records: retained for 3 years for medical audit compliance',
              'AI chat history: retained for 1 year to improve service quality',
              'You can request full deletion of your account and data at any time',
            ]
          },
          {
            icon: '✅', title: '7. Your Rights',
            items: [
              'Access: Request a copy of data we hold about you',
              'Correction: Request correction of any inaccurate data',
              'Deletion: Request full deletion of your account and all data',
              'Opt-Out: Unsubscribe from promotional notifications anytime',
              'Contact us: privacy@hcen.in',
            ]
          },
          {
            icon: '📞', title: '8. Contact Us',
            items: [
              'Email: privacy@hcen.in',
              'HCEN Healthcare Pvt. Ltd., India',
              'For data deletion requests or privacy concerns, email us and we will respond within 48 hours.',
            ]
          },
        ].map(section => (
          <div key={section.title} style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', marginBottom: 14, border: '1px solid #f0f0f0', boxShadow: '0 1px 6px rgba(0,0,0,0.04)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 20 }}>{section.icon}</span>
              <span style={{ fontWeight: 700, fontSize: 15, color: '#d32f2f' }}>{section.title}</span>
            </div>
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {section.items.map((item, i) => (
                <li key={i} style={{ color: '#444', fontSize: 13.5, lineHeight: 1.7, marginBottom: 5 }}>{item}</li>
              ))}
            </ul>
          </div>
        ))}

        <div style={{ textAlign: 'center', marginTop: 28, fontSize: 12, color: '#aaa' }}>
          © {new Date().getFullYear()} HCEN Healthcare Pvt. Ltd. · <Link to="/terms" style={{ color: '#d32f2f' }}>Terms & Conditions</Link>
        </div>
      </div>
    </div>
  );
}
